import { AdminClinicSwitchErrorResponse } from '@companion-professional/dctypes';

export const isAdminClinicSwitchErrorResponse = (value: any): value is AdminClinicSwitchErrorResponse => {
  return value && typeof value?.switch_clinic_id === 'string' && typeof value?.error === 'string';
};
